import { BRAND } from '../palette';
import type { MacroItem } from '../marketContext';

/**
 * Macro cells — count varies by product (IDR shows the live Rupiah card plus a
 * BI-Rate card whenever the server has a bi.go.id quote; Yield SBN 10Y and
 * Inflasi Domestik were removed for lacking a free public data source; USD
 * shows Fed Funds Rate and US Treasury 10Y). Below 4 items the
 * strip shrink-wraps to fixed-width cells instead of stretching a lone card
 * across the full row. Values are ink (#1B2436), never #a98131.
 */
export function SflMacroStrip({ items, asOfLabel }: { items: MacroItem[]; asOfLabel: string }) {
  const isFullRow = items.length >= 4;
  return (
    <div>
      <p
        className="mb-2 uppercase"
        style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 10,
          letterSpacing: '1.5px',
          color: BRAND.textFaint,
        }}
      >
        {asOfLabel}
      </p>
      <div
        className="sfl-macro-strip"
        style={{
          gridTemplateColumns: isFullRow
            ? `repeat(${items.length}, 1fr)`
            : `repeat(${items.length}, minmax(200px, 240px))`,
          width: isFullRow ? '100%' : undefined,
        }}
      >
        {items.map((item) => (
          <div key={item.label} className="bg-white px-5 py-[18px]">
            <p
              className="uppercase mb-2"
              style={{
                fontFamily: 'var(--font-sans)',
                fontSize: 10,
                letterSpacing: '1px',
                color: BRAND.textFaint,
              }}
            >
              {item.label}
            </p>
            <p
              className="tabular-nums"
              style={{ fontSize: 20, color: BRAND.ink, fontFamily: 'var(--font-display)', lineHeight: 1.2 }}
            >
              {item.value}
            </p>
            <p className="mt-1" style={{ fontFamily: 'var(--font-sans)', fontSize: 11, color: BRAND.textFaint }}>
              {item.note}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
